export const getDropDownItem = (items?: string[]) => items && items[0];

export default getDropDownItem;
